<div class="container">

    <!-- HEADER -->
    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="19" y1="5" x2="5" y2="19"/>
                <circle cx="6.5" cy="6.5" r="2.5"/>
                <circle cx="17.5" cy="17.5" r="2.5"/>
            </svg>
        </div>
        <div style="flex:1">
            <h1>Consultar IPI</h1>
            <p>Consulte a alíquota pelo NCM com o incentivo aplicado</p>
        </div>
        <span class="moeda">USD · Dólar americano</span>
    </div>

    <!-- CONSULTA INDIVIDUAL -->
    <div class="card">
        <div class="card-title">Consulta individual</div>

        <form class="ipi-form" (ngSubmit)="consultar()">
            <div class="field field-wide">
                <label for="consulta-ipi-ncm">Código NCM</label>
                <input id="consulta-ipi-ncm" name="ncm" [(ngModel)]="ncm" (ngModelChange)="limparResultado()"
                       placeholder="8511.20.10" inputmode="numeric" autocomplete="off" maxlength="12"
                       [disabled]="carregando()" aria-describedby="ipi-ajuda">
                <small id="ipi-ajuda">Digite os 8 dígitos, com ou sem pontos.</small>
            </div>
            <button type="submit" class="btn primary" [disabled]="carregando()">{{ carregando() ? 'Consultando…' : 'Consultar IPI' }}</button>
        </form>

        <p *ngIf="carregando()" role="status" class="ipi-status">Consultando a alíquota do NCM…</p>
        <p *ngIf="erro()" role="alert" class="ipi-erro">{{ erro() }}</p>

        <article *ngIf="resultado() as item" class="ipi-resultado" aria-live="polite">
            <div class="ipi-ncm">NCM {{ item.ncm }}</div>
            <h2>{{ item.descricao }}</h2>
            <div class="aliquotas">
                <div><span>Alíquota original</span><strong>{{ item.aliquotaOriginal === null ? item.tributacao : (item.aliquotaOriginal | number:'1.0-4':'pt-BR') + '%' }}</strong></div>
                <div class="incentivo"><span>IPI com incentivo</span><strong>{{ item.aliquotaIncentivo === null ? item.tributacao : (item.aliquotaIncentivo | number:'1.0-5':'pt-BR') + '%' }}</strong><small>Alíquota original ÷ 10</small></div>
            </div>
            <p *ngFor="let observacao of item.observacoes" class="ipi-observacao">{{ observacao }}</p>
            <footer>Fonte: <a href="https://www.gov.br/receitafederal/pt-br/acesso-a-informacao/legislacao/tipi-tabela-de-incidencia-do-imposto-sobre-produtos-industrializados" target="_blank" rel="noopener noreferrer">{{ item.fonte }}</a> · Consulta à fonte: {{ item.atualizadoEm | date:'dd/MM/yyyy HH:mm' }}</footer>
        </article>
    </div>

    <!-- COMPARATIVO COM O AEROSYS -->
    <div class="card">
        <div class="card-title">Comparativo com o Aerosys</div>
        <p class="comparativo-intro">Parte dos NCMs distintos da FISCAL_NCM, consulta a alíquota real da Receita pra cada um e busca produto por produto (por ID) os que usam esses NCMs. Busca produto por produto de propósito: um produto do Aerosys tem um fabricante órfão que faz a listagem completa quebrar com erro 500 — buscando um a um, só esse produto fica de fora, o resto carrega normal.</p>

        <div class="comparativo-intervalo">
            <div class="field col-1">
                <label>ID inicial</label>
                <input type="number" min="1" [(ngModel)]="idInicial" name="idInicial" [ngModelOptions]="{standalone: true}" [disabled]="comparando()">
            </div>
            <div class="field col-1">
                <label>ID final</label>
                <input type="number" min="1" [(ngModel)]="idFinal" name="idFinal" [ngModelOptions]="{standalone: true}" [disabled]="comparando()">
            </div>
            <button type="button" class="btn primary" (click)="compararComAerosys()" [disabled]="comparando()">
                {{ comparando() ? 'Buscando…' : 'Comparar com Aerosys' }}
            </button>
            <small class="comparativo-hint">Cada produto é buscado individualmente (não uma listagem única) — intervalos grandes demoram mais. Ajuste conforme o maior código de produto (APE_ID) do seu catálogo.</small>
        </div>

        <p *ngIf="comparando()" role="status" class="ipi-status">Verificando os IDs {{ idInicial }}–{{ idFinal }} no Aerosys, um produto de cada vez…</p>
        <p *ngIf="erroComparativo()" role="alert" class="ipi-erro">{{ erroComparativo() }}</p>

        <ng-container *ngIf="ultimoIdVerificado() > 0">
            <p class="comparativo-resumo">
                {{ totalNcmsFiscalNcm() }} NCMs na FISCAL_NCM · IDs verificados até agora: 1–{{ ultimoIdVerificado() }} ({{ totalProdutosEncontrados() }} produtos encontrados) · {{ itensComparativo().length }} de {{ totalLinhasAcumuladas() }} linhas exibidas
            </p>
            <div class="comparativo-acoes">
                <label class="comparativo-filtro">
                    <input type="checkbox" [(ngModel)]="somenteIpiMaiorQueZero" name="somenteIpiMaiorQueZero" [ngModelOptions]="{standalone: true}">
                    Mostrar somente NCMs com alíquota da Receita maior que zero
                </label>
                <button type="button" class="btn secondary" (click)="carregarProximoIntervalo()" [disabled]="comparando()">
                    {{ comparando() ? 'Buscando…' : 'Carregar mais ' + TAMANHO_PADRAO_INTERVALO + ' IDs (' + (ultimoIdVerificado() + 1) + '–' + (ultimoIdVerificado() + TAMANHO_PADRAO_INTERVALO) + ')' }}
                </button>
            </div>
            <div class="comparativo-tabela-wrap">
                <table class="comparativo-tabela">
                    <thead>
                        <tr>
                            <th>NCM</th>
                            <th>PN</th>
                            <th>Código (APE_ID)</th>
                            <th>IPI Entrada (produto)</th>
                            <th>IPI Saída (produto)</th>
                            <th>IPI Entrada (FISCAL_NCM)</th>
                            <th>IPI Saída (FISCAL_NCM)</th>
                            <th>Alíquota real (Receita)</th>
                            <th>Alíquota ÷10 (incentivo)</th>
                            <th>Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let linha of itensComparativo()" [class.linha-atencao]="linha.situacaoReceita !== 'OK'">
                            <td>{{ linha.ncm }}</td>
                            <td>{{ linha.pn || '—' }}</td>
                            <td>{{ linha.apeId }}</td>
                            <td>{{ linha.ipiEntradaProduto === null ? '—' : (linha.ipiEntradaProduto | number:'1.0-4':'pt-BR') + '%' }}</td>
                            <td>{{ linha.ipiSaidaProduto === null ? '—' : (linha.ipiSaidaProduto | number:'1.0-4':'pt-BR') + '%' }}</td>
                            <td>{{ linha.ipiEntradaFiscalNcm === null ? '—' : (linha.ipiEntradaFiscalNcm | number:'1.0-4':'pt-BR') + '%' }}</td>
                            <td>{{ linha.ipiSaidaFiscalNcm === null ? '—' : (linha.ipiSaidaFiscalNcm | number:'1.0-4':'pt-BR') + '%' }}</td>
                            <td>{{ linha.aliquotaReceitaOriginal === null ? '—' : (linha.aliquotaReceitaOriginal | number:'1.0-4':'pt-BR') + '%' }}</td>
                            <td>{{ linha.aliquotaReceitaIncentivo === null ? '—' : (linha.aliquotaReceitaIncentivo | number:'1.0-5':'pt-BR') + '%' }}</td>
                            <td>
                                <span *ngIf="linha.situacaoReceita === 'OK'">OK</span>
                                <span *ngIf="linha.situacaoReceita === 'NAO_ENCONTRADO'" title="{{ linha.observacao }}">NCM não encontrado na TIPI</span>
                                <span *ngIf="linha.situacaoReceita === 'EXIGE_ENQUADRAMENTO'" title="{{ linha.observacao }}">Exige enquadramento</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>
</div>
